<template>
  <b-row>
    <b-col class="d-flex justify-content-center">
      <div
        :class="['item item-width p-2', { active: activeProductType == 'Suite' }]"
        @click="accountType('Suite')"
      >
        <img src="@/assets/images/icons/Account-Suite-Gradient.svg" height="20" class="image-item" />
      </div>
      <div
        :class="[
          'item item-width p-2',
          { active: activeProductType == 'Card Account' },
          {
            'disable-side-btn': disable,
          },
        ]"
        @click="accountType('Card Account')"
      >
        <img src="@/assets/images/icons/Account-Credit-Gradient.svg" height="20" class="image-item" />
      </div>
      <div
        :class="[
          'item item-width p-2',
          { active: activeProductType == 'Transaction Account (bundled fees)' },
          {
            'disable-side-btn': disable,
          },
        ]"
        @click="accountType('Transaction Account (bundled fees)')"
      >
        <img src="@/assets/images/icons/Account-Transaction-Gradient.svg" height="20" class="image-item" />
      </div>
      <div
        :class="[
          'item p-2',
          {
            active:
              activeProductType ==
              'Transaction Account (pay-as-you-transact fees)',
          },
          {
            'disable-side-btn': disable,
          },
        ]"
        @click="accountType('Transaction Account (pay-as-you-transact fees)')"
      >
        <img src="@/assets/images/icons/money_grey.png" height="20" class="image-item" />
      </div>
      <div
        :class="['run item-width p-2', { active: healthMemberActive == 'no' }]"
        @click="healthMemberAction()"
      >
        
          <img src="@/assets/images/icons/running_man.svg" height="20" class="image-item" />
       
      </div>
      <div
        :class="['car item-width p-2', { active: driveMemberActive == 'no' }]"
        @click="driveMemberAction()"
      >
        <img src="@/assets/images/icons/car.svg" alt="" height="20" class="image-item" />
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    compare: { default: 1 },
    driveMemberActive: {
      default: "yes",
    },
    healthMemberActive: {
      default: "yes",
    },
    activeProductType: {
      default: "Suite",
    },
    disable: {
      default: false,
    },
  },
  data() {
    return {
      driveMemberAct: this.driveMemberActive,
      healthMemberAct: this.healthMemberActive,
    };
  },
  methods: {
    driveMember(item) {},
    accountType(item) {
      if(this.disable!=true){
      this.$emit("account", item);
      }
    },
    healthMember(item) {
      this.$emit("health", item);
    },

    driveMemberAction() {
      if (this.driveMemberActive == "yes") {
        this.$emit("drive", "no");
      } else {
        this.$emit("drive", "yes");
      }
    },
    healthMemberAction() {
      if (this.healthMemberActive == "yes") {
        this.$emit("health", "no");
      } else {
        this.$emit("health", "yes");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  background-color: white;
  &.active {
    color: black;
    border-bottom: 0.3em solid black;
    border-left-width: 0;
    border-right-width: 0;
    border-top-width: 0;
    border-image: linear-gradient(
        90deg,
        rgba(0, 212, 255, 1) 0%,
        rgba(102, 80, 244, 1) 25%,
        rgba(147, 23, 223, 1) 50%,
        rgba(249, 1, 157, 1) 78%
      )
      5;
  }
}
.car {
  background-color: #8b50ae;
  &.active {
    background-color: #878686;
  }
}
.run {

  background-color: #218ae5;
  &.active {
    background-color: #878686;
  }
}
.item-width{
  width:3.2em;
  text-align: center;
}

</style>